import React from "react";
import { RenderHtml } from "./render-html";

type Props = {
  className: string;
  id: string;
};

export function Icon({ id, className }: Props) {
  const html = `
    <x-icon>
      <script type="application/json" name="id">"${id}"</script>
      <script type="application/json" name="className">"${className}"</script>
    </x-icon>
  `;

  return <RenderHtml html={html} />;
}
